export interface ClarifyOption { value?: string; label: string; }
export interface ClarifyQuestion { id?: string; text: string; multi?: boolean; options: ClarifyOption[]; }
export interface ClarifySpec { questions: ClarifyQuestion[]; }

const ASK_RE = /```ask\s*([\s\S]*?)```/g;
const MAX_Q = 4, MAX_OPT = 6;

export function parseClarifyBlock(content: string): { cleaned: string; clarify: ClarifySpec | null } {
  if (!content) return { cleaned: content, clarify: null };
  const matches = Array.from(content.matchAll(ASK_RE));
  if (matches.length === 0) return { cleaned: content, clarify: null };
  const last = matches[matches.length - 1];
  try {
    const raw = JSON.parse(last[1].trim());
    const questions = Array.isArray(raw?.questions) ? raw.questions : null;
    if (!questions) return { cleaned: content, clarify: null };
    const norm: ClarifyQuestion[] = questions.slice(0, MAX_Q)
      .filter((q: any) => q && typeof q.text === 'string' && Array.isArray(q.options))
      .map((q: any) => ({
        id: typeof q.id === 'string' ? q.id : undefined,
        text: q.text,
        multi: q.multi === true,
        options: q.options.filter((o: any) => o && typeof o.label === 'string')
          .slice(0, MAX_OPT)
          .map((o: any) => ({ value: o.value, label: o.label })),
      }))
      .filter((q: ClarifyQuestion) => q.options.length > 0);
    if (norm.length === 0) return { cleaned: content, clarify: null };
    const cleaned = content.replace(last[0], '').trim();
    return { cleaned, clarify: { questions: norm } };
  } catch {
    return { cleaned: content, clarify: null };
  }
}

export function questionKey(q: ClarifyQuestion, index: number): string {
  return q.id ?? `q${index}`;
}

export function buildClarifyAnswer(
  questions: ClarifyQuestion[],
  selections: Record<string, string[]>,
): string {
  const answered = questions
    .map((q, i) => ({ q, labels: selections[questionKey(q, i)] ?? [] }))
    .filter((x) => x.labels.length > 0);
  if (answered.length === 1 && questions.length === 1 && !questions[0].multi) {
    return answered[0].labels[0];
  }
  return answered.map((x) => `${x.q.text} ${x.labels.join(', ')}`).join('\n');
}
